import { FinancialAssetDto, LifeInsuranceDto, RealEstateDto, VehicleDto } from "@/lib/DTMWebAPIClient.generated";
import { RootState } from "@/store/dtm";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface expenseInfo {
    displayId: string,
    id: number,
    assetId: number,
    expenseCategory: string,
    propertyTax: number,
    heatingCost: number,
    maintenanceFee: number,
    ownershipPercentage: number,
    applicants: number[]
}

export interface expenseState {
    expenses: expenseInfo[],
}

const initialState: expenseState = {
    expenses: [],
}


export const expenseSlice = createSlice({
    name: "expense",
    initialState,
    reducers: {
        addExpense: (state, action: PayloadAction<expenseInfo>) => {
            const expense = action.payload;
            state.expenses.push(expense);
        },
        setExpenseInfo: (state, action: PayloadAction<expenseInfo>) => {
            const expenseInfo = action.payload;
            state.expenses = state.expenses.map(expense => expense.id == expenseInfo.id ? expenseInfo : expense);
        },
        removeExpense: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.expenses = state.expenses.filter(expense => expense.id != id);
            //Reset the displayId of remaining expenses
            state.expenses = state.expenses.map((expense, index) => ({
                ...expense,
                displayId: `${index + 1}`
            }));
        },
        clearExpenseState: (state) => {
            state.expenses = [];
        }
    }
});

export const { addExpense, setExpenseInfo, removeExpense, clearExpenseState } = expenseSlice.actions

export default expenseSlice.reducer

export const selectExpense = (state: RootState) => state.expenses;